import React, { Component } from "react";
import {
    Form,
    InputNumber,
} from "antd";

export const currencyFormatter = value => {
    let ret = `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return ret
};
export const currencyParser = value => {
    let ret = value.replace(/\$\s?|(,*)/g, '');
    return ret
};

class FormItemDollarAmount extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    };


    render() {
        return (
            <Form.Item
                label={this.props.label}
                name={this.props.name}
                rules={[{ required: true, message: "Please input " + this.props.name }]}
                onChange={this.props.onChange}
            >
                <InputNumber
                    defaultValue={this.props.placeholder}
                    prefix="$"
                    style={{ width: "100%" }}
                    formatter={(value) => currencyFormatter(value)
                    }
                    parser={(value) => currencyParser(value)}
                />
            </Form.Item>
        );
    }
};

export default FormItemDollarAmount;